export default "__VITE_ASSET__BXJuXxS2__"